import React from 'react';
import { connect } from 'react-redux';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import { content } from '@/components/Cluster/TopicTip';
import SummaryPanel from '@/components/Cluster/SummaryPanel';
import PermWrapper from '@/components/PermWrapper';

function Summary({ overview, loading }) {
  const items = [
    {
      title: '租户',
      info: <CountUp end={overview.totalTenantCount} duration={0.4} />,
      icon: 'other2',
      unit: '个',
    },
    {
      title: '命名空间',
      info: <CountUp end={overview.totalNamespaceCount} duration={0.4} />,
      icon: 'other3',
      unit: '个',
    },
    {
      title: 'Topic',
      icon: 'topic',
      info: (
        <>
          <CountUp end={overview.totalTopicPartitionCount} duration={0.4} />/
          <CountUp end={overview.totalTopicCount} duration={0.4} />
        </>
      ),
      unit: '个',
      tip: content,
    },
    {
      title: '订阅',
      icon: 'subscription',
      info: (
        <>
          <CountUp end={overview.totalSubscriptionOnlineCount} duration={0.4} />/
          <CountUp end={overview.totalSubscriptionCount} duration={0.4} />
        </>
      ),
      unit: '个',
      tip: (
        <div>
          <strong>
            订阅({overview.totalSubscriptionOnlineCount || 0}/{overview.totalSubscriptionCount || 0}
            )
          </strong>
          <li>{overview.totalSubscriptionOnlineCount || 0}代表在线订阅数。</li>
          <li>{overview.totalSubscriptionCount || 0}代表总订阅数。</li>
        </div>
      ),
    },
  ];
  return (
    <PermWrapper resource='pulsar:tenant:list:summary'>
      <Loading loading={loading} size='small'>
        <SummaryPanel shadow items={items} />
      </Loading>
    </PermWrapper>
  );
}

export default connect((state) => ({
  overview: state.tenant.overview,
  loading: state.tenant.loading,
}))(Summary);
